import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";

/* ─────────────────────────────────────────
   ⬇️ MODIFIABLE
   ───────────────────────────────────────── */
const COMPANY_NAME = "SlimeTech";

const NAV_LINKS = [
  { id: "hero",     label: "Accueil"  },
  { id: "services", label: "Services" },
  { id: "contact",  label: "Contact"  },
];

const Footer = () => {
  const year = new Date().getFullYear();
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "";

  const handleNav = useCallback((e, sectionId) => {
    e.preventDefault();
    if (isHome) {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = `/#${sectionId}`;
    }
  }, [isHome]);

  return (
    <footer className="p-footer">
      {/* ─── Grille principale ─── */}
      <div className="p-footer-grid">

        {/* Colonne 1 — Brand */}
        <div>
          <a
            href="/"
            className="footer-brand-logo"
            onClick={(e) => {
              e.preventDefault();
              if (isHome) {
                window.scrollTo({ top: 0, behavior: "smooth" });
              } else {
                window.location.href = "/";
              }
            }}
          >
            <img
              src="/images/logo-slime-tech.png"
              alt={`${COMPANY_NAME} — Développeur web freelance`}
              className="p-logo-img p-logo-img--footer"
              width="120"
              height="40"
              loading="lazy"
            />
          </a>
          <p className="footer-brand-desc">
            Développeur web freelance — sites vitrines, applications web et conseils techniques sur-mesure.
          </p>
        </div>

        {/* Colonne 2 — Navigation */}
        <div>
          <span className="footer-col-title">Navigation</span>
          <ul className="footer-col-links">
            {NAV_LINKS.map(({ id, label }) => (
              <li key={id}>
                <a href={`/#${id}`} onClick={(e) => handleNav(e, id)}>{label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Colonne 3 — Légal */}
        <div>
          <span className="footer-col-title">Légal</span>
          <ul className="footer-col-links">
            <li><a href="/mentions-legales">Mentions légales</a></li>
          </ul>
        </div>
      </div>

      {/* ─── Bas de page ─── */}
      <div className="p-footer-bottom">
        <div className="p-footer-bottom-inner">
          {/* ⬇️ MODIFIABLE */}
          <span>&copy; {year} {COMPANY_NAME} — Tous droits réservés.</span>
          <span>
            Conçu &amp; développé avec{" "}
            <i className="bi bi-heart-fill" style={{ color: "#e879f9" }} />{" "}
            en France
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
